import gql from 'graphql-tag';

import microsoftTeamsRemoteItemsPageFragment from '../fragments/microsoftTeamsRemoteItemsPageFragment';

export const queryMicrosoftTeamsRemoteItemsPage = gql`
  query microsoftTeamsRemoteItemsPage(
    $credentialID: DokkioID!
    $parentFolderRemoteID: String
    $token: String
  ) {
    microsoftTeamsRemoteItemsPage(
      credentialID: $credentialID
      parentFolderRemoteID: $parentFolderRemoteID
      token: $token
    ) {
      ...microsoftTeamsRemoteItemsPageFragment
    }
  }
  ${microsoftTeamsRemoteItemsPageFragment}
`;

export default queryMicrosoftTeamsRemoteItemsPage;
